<h2 mat-dialog-title>{{('chooseVehicle' | translate)}} </h2>

<form [formGroup]="formGroup" (ngSubmit)="submit()">

<mat-dialog-content fxLayout="column">
    <mat-form-field class="pt-2 pb-2">
        <mat-label [style.fontSize]="'12px'">{{'side_number' | translate | titlecase}}</mat-label>
        <mat-select [style.fontSize]="'18px'" formControlName="vehSideNumber" multiple="{{data.multiple}}">
            <mat-option *ngFor="let veh of vehicles" [value]="veh.sideNumber">
                {{veh.sideNumber}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions fxLayoutAlign="end" class="pt-4 pb-4">
    <button mat-raised-button mat-dialog-close color="sims">{{'close' | translate}}</button>
    <button mat-raised-button type="submit" color="sims" [disabled]="!formGroup.valid">{{'submit' | translate | titlecase}}</button>
</mat-dialog-actions>

</form>